import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';

const RequestFullDetermination = ({ exchangeName, toggleEnabled, onSubmitCb, fullDeterminationSubmitted, link }) => {
    const [contentCollapsed, toggle] = useState(toggleEnabled);


    const toggleContent = (e) => {
        e.preventDefault();
        toggle(!contentCollapsed);
    };

    return (
        <div className="request-determination">
            { fullDeterminationSubmitted ?
                <FormattedMessage id="eligibility_results.request_determination_submitted" tagName="p"/> :

                <Fragment>
                    <FormattedMessage 
                        id="eligibility_results.request_determination_p1" 
                        tagName="p"
                        values={{
                            exchangeName
                        }}
                    />
                    { toggleEnabled &&
                    <p className="request-determination__toggle">
                        <FormattedMessage
                            id="eligibility_results.request_determination_toggle"
                            values={{
                                secondPart:
                                    <a id="requrestDeterminationToggle"
                                        onClick={toggleContent}
                                        href="#">
                                        <FormattedMessage id="common.click_here"/>
                                    </a>
                            }}
                        />
                    </p>
                    }
                    { !contentCollapsed &&
                    <div className="request-determination__content">
                        <FormattedMessage id='eligibility_results.request_determination_expanded' tagName='p' values={{ link }}
                        />
                        <Button
                            id='eligibilityRequestFullDetermination'
                            className='usa-button usa-button--outline gi-button gi-button__outline eligibility_CTA'
                            onClick={onSubmitCb}
                        >
                            <FormattedMessage id='button.request_full_determination'/>
                        </Button>
                    </div>
                    }
                </Fragment>
            }
        </div>
    );
};

export default RequestFullDetermination;